import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { Pagination } from 'element-ui';
import { DatePicker } from 'element-ui';
import { Button } from 'element-ui';

// 引入各个语言配置文件
import zh from './zh';
// import en from './en'; // 初始提交版本
import en_v1 from './en_v1';  //第一次英文校验版本

import enlocale from 'element-ui/lib/locale/lang/en';
import zhlocale from 'element-ui/lib/locale/lang/zh-CN';
import ElementLocale from 'element-ui/lib/locale';

Vue.use(VueI18n);
Vue.use(Pagination);
Vue.use(DatePicker);
Vue.use(Button);

//  合并两个对象的方法，ES6的扩展运算符
// const messages = {
//   en: {
//     message: 'hello',
//     ...enLocale
//   },
//   zh: {
//     message: '你好',
//     ...zhLocale
//   }
// }

// let obj = Object.assign({}, obj1, obj2); // 合并两个对象的另外一种方法
const zhobj = Object.assign({}, zh, zhlocale);
const enobj = Object.assign({}, en_v1, enlocale);

const messages = {
  en: enobj,
  zh: zhobj
}

// 创建vue-i18n实例i18n
const i18n = new VueI18n({
  // 设置默认语言
  locale: localStorage.getItem('locale') || 'en', // 语言标识,页面对应显示相同的语言// 添加多语言（每一个语言标示对应一个语言文件）
  messages: messages
})

ElementLocale.i18n((key, value) => i18n.t(key, value))

// 暴露i18n
export default i18n;


// WEBPACK FOOTER //
// ./src/lang/index.js